import _objectWithoutProperties from "/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import "core-js/modules/es.array.reduce.js";
import { Slot as e } from "@radix-ui/react-slot";
import * as r from "react";
import i from "@babel/runtime/helpers/esm/extends";
export var Primitive = ["a", "button", "div", "h2", "h3", "img", "li", "nav", "p", "span", "svg", "ul"].reduce(function (t, s) {
  return _objectSpread(_objectSpread({}, t), {}, _defineProperty({}, s, /*#__PURE__*/r.forwardRef(function (t, n) {
    var a = t.asChild,
        m = _objectWithoutProperties(t, ["asChild"]),
        d = a ? e : s;

    return r.useEffect(function () {
      window[Symbol.for("radix-ui")] = !0;
    }, []), t.as && console.error(o), /*#__PURE__*/r.createElement(d, i({}, m, {
      ref: n
    }));
  })));
}, {});
var o = "Warning: The `as` prop has been removed in favour of `asChild`. For details, see https://radix-ui.com/docs/primitives/overview/styling#changing-the-rendered-element";
export var Root = Primitive;